import StatisticButton from './component';

export default StatisticButton;
